// extracted by mini-css-extract-plugin
module.exports = {"legalInformation":"_3ZSn0nxtRbjK4viyxJgmIW"};